// src/js/index.js
import { initializeCarousel } from './carouselProduct';
import { initializeSeedCarousel } from './seedCarousel';
import { initializeCarouselFeed } from './carouselFeed';
import { initializeCarouselReceip } from './carouselReceip';
import { initShopTheLock } from './shop-the-lock';
import { PDPFunctions } from './pdpFunct';
import { positionDropdown } from './customVariantSelect';

// Llamar a la función para inicializar el carrusel
function addMobileClassToMenu() {}
document.addEventListener('DOMContentLoaded', function () {
  /* initializeSeedCarousel(); */
  initializeCarousel();
  initializeCarouselFeed();
  initializeCarouselReceip();
  initShopTheLock();
  PDPFunctions();
  positionDropdown();
  var headerMenu = document.querySelector('.header__inline-menu');
  if (window.innerWidth < 900) {
    headerMenu.classList.add('mobile-menu');
  } else {
    headerMenu.classList.remove('mobile-menu');
  }
});